<template>
  <v-card class="pa-4">
    <h3>{{$lang.labels.printTemplateActivationText}}</h3>
    <v-layout row wrap justify-space-between pt-2>
      <v-btn flat @click="$emit('activate', 0)" class="mx-0">{{$lang.actions.no}}</v-btn>
      <v-btn color="primary" @click="$emit('activate', 1)" class="mx-0">{{$lang.actions.yes}}</v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    data: () => ({

    }),
    methods: {
    },
    created() {
    }
  }
</script>



// WEBPACK FOOTER //
// PrintTemplateActivationModal.vue?b091e0ca